/**
 * HostContextProvider — declarative React context that surfaces use to
 * pass current page state ({ currentTaskId, currentProjectId, customerId,
 * … }) into every conversation turn. The engine reads this via
 * `useHostContext()` and rides it on each `POST /messages`.
 */

import { createContext, type ReactNode, useContext } from 'react'

const HostContextValue = createContext<Record<string, unknown> | null>(null)

export function HostContextProvider({ value, children }: { value?: Record<string, unknown>; children: ReactNode }) {
  return <HostContextValue.Provider value={value ?? null}>{children}</HostContextValue.Provider>
}

export function useHostContext(): Record<string, unknown> | null {
  return useContext(HostContextValue)
}
